// Slice contenant les etats de gestion du layout etcrm
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from "@reduxjs/toolkit";
import { DisplaySize } from "@/utils/display";
import { Slot } from "@/utils/types/layout";
import { logger } from "@/utils/loggerService";
import { merge } from "lodash";
import copy from "fast-copy";
import { slotDirection, slotSize } from "@/utils/funcs";
var slots = Object.fromEntries(Object.values(Slot).map(function (slot) {
    return [slot, { widgets: [], enabled: true, edited: false }];
}));
/**
 *
 */
var initialState = {
    // Visibilité des emplacements
    headerEnabled: true,
    footerEnabled: true,
    areaEnabled: true,
    menuEnabled: true,
    docksEnabled: true,
    previewEnabled: true,
    // Taille d'affichage
    displaySize: DisplaySize.SMALL,
    // Editing layout
    editingLayout: false,
    //
    slots: slots,
    //
    display: true,
    moduleList: [],
};
export var layoutSliceState = createSlice({
    name: "layout",
    initialState: initialState,
    reducers: {
        setWidgetDisplay: function (state, action) {
            state.display = action.payload;
        },
        setDisplaySize: function (state, action) {
            state.displaySize = action.payload;
        },
        addWidget: function (state, action) {
            var _a = action.payload, id = _a.id, actionUrl = _a.actionUrl, module = _a.module, preferedSlot = _a.slot, pinned = _a.pinned, order = _a.order, widgetData = _a.widget;
            if (!widgetData) {
                logger.warn("[LAYOUT] - Les propri\u00E9t\u00E9s du widget sont requises.");
                return;
            }
            var type = widgetData.type, payload = widgetData.payload;
            if (!id || !type) {
                logger.debug("[LAYOUT] - Erreur lors de l'ajout du widget. (id = ".concat(id, ", type = ").concat(type, ")"));
                return;
            }
            if (!Object.hasOwn(state.slots, preferedSlot)) {
                logger.warn("[LAYOUT] - Slot inconu: ".concat(preferedSlot, ". Le widget sera mis dans \"main\""));
            }
            var slot = preferedSlot ? preferedSlot : Slot.MAIN;
            var direction = slotDirection(slot);
            var size = slotSize(slot);
            var widget = {
                id: id,
                actionUrl: actionUrl,
                module: module,
                type: type,
                slot: slot,
                payload: payload,
                meta: {
                    order: order || 0,
                    visible: true,
                    pinned: pinned || false,
                    direction: direction,
                    size: size,
                },
            };
            logger.debug("[LAYOUT] - Ajout du widget dans le slot: ".concat(slot), widget);
            state.slots[slot].widgets.push(widget);
        },
        updateWidget: function (state, action) {
            var _a = action.payload, id = _a.id, actionUrl = _a.actionUrl, module = _a.module, widgetType = _a.type, widgetSlot = _a.slot, pinned = _a.pinned, order = _a.order, visible = _a.visible, widgetData = _a.widget;
            if (!widgetData) {
                logger.warn("[LAYOUT] - Les propri\u00E9t\u00E9s du widget sont requises.");
                return;
            }
            var type = widgetData.type, payload = widgetData.payload;
            if (!id) {
                logger.debug("[LAYOUT] - Erreur lors de la modification du widget. (id = ".concat(id, ", type = ").concat(widgetType, ")"));
                return;
            }
            if (!Object.hasOwn(state.slots, widgetSlot)) {
                logger.warn("[LAYOUT] - Slot inconu: ".concat(widgetSlot, ". Le widget sera recherch\u00E9 dans \"main\""));
            }
            var slot = widgetSlot || Slot.MAIN;
            var widgets = state.slots[slot].widgets;
            var widgetIndex = widgets.findIndex(function (w) {
                return id && w.id === id && (widgetType ? w.type === widgetType : true);
            });
            logger.debug("[LAYOUT] - Current widget location: ".concat(widgetIndex));
            var widget = widgets[widgetIndex];
            if (!widget) {
                logger.warn("[LAYOUT] - Le widget ".concat(id, " n'existe pas dans le slot: ").concat(slot));
                return;
            }
            logger.debug("[LAYOUT] - Mise \u00E0 jour du widget ".concat(id, " depuis le slot: ").concat(slot));
            var updatedWidget = merge(copy(widget), {
                type: type,
                payload: payload !== undefined ? payload : widget.payload,
                meta: __assign(__assign({}, widget.meta), widgetData.meta),
                /*meta: {
                  pinned: pinned !== undefined ? pinned : widget.meta?.pinned,
                  visible: visible !== undefined ? visible : widget.meta?.visible,
                  order: order !== undefined ? order : widget.meta?.order,
                },*/
            });
            state.slots[slot].widgets[widgetIndex] = updatedWidget;
        },
        removeWidget: function (state, action) {
            var _a = action.payload, id = _a.id, type = _a.type, widgetLocation = _a.slot;
            if (!id && !type) {
                logger.warn("[LAYOUT] - L'identifiant du widget ou le type est requis");
                return;
            }
            if (!Object.hasOwn(state.slots, widgetLocation)) {
                logger.warn("[LAYOUT] - Slot inconu: ".concat(widgetLocation, ". Le widget sera recherch\u00E9 dans \"main\""));
            }
            var slot = widgetLocation || Slot.MAIN;
            logger.debug("[LAYOUT] - Suppression du widget ".concat(id, "/").concat(type, " depuis le slot: ").concat(slot));
            state.slots[slot].widgets = state.slots[slot].widgets.filter(function (w) { return (id ? w.id !== id : true) || (type ? w.type !== type : true); });
        },
        removeWidgetById: function (state, action) {
            layoutSliceState.caseReducers.removeWidget(state, action);
        },
        removeWidgetByType: function (state, action) {
            layoutSliceState.caseReducers.removeWidget(state, action);
        },
        setWidget: function (state, action) {
            var _a = action.payload, id = _a.id, actionUrl = _a.actionUrl, module = _a.module, preferedSlot = _a.slot, pinned = _a.pinned, order = _a.order, widgetData = _a.widget;
            if (!widgetData) {
                logger.warn("[LAYOUT] - Les propri\u00E9t\u00E9s du widget sont requises.");
                return;
            }
            var type = widgetData.type, payload = widgetData.payload;
            if (!id || !type) {
                logger.debug("[LAYOUT] - Erreur lors de l'ajout du widget. (id = ".concat(id, ", type = ").concat(type, ")"));
                return;
            }
            if (!Object.hasOwn(state.slots, preferedSlot)) {
                logger.warn("[LAYOUT] - Slot inconu: ".concat(preferedSlot, ". Le widget sera mis dans \"main\""));
            }
            var slot = preferedSlot ? preferedSlot : Slot.MAIN;
            var direction = slotDirection(slot);
            var size = slotSize(slot);
            var widget = {
                id: id,
                type: type,
                actionUrl: actionUrl,
                module: module,
                payload: payload,
                slot: slot,
                meta: {
                    order: order || 0,
                    visible: true,
                    pinned: pinned || false,
                    direction: direction,
                    size: size,
                },
            };
            logger.debug("[LAYOUT] - Remplacement du widget dans le slot: ".concat(slot), widget);
            state.slots[slot].widgets = [widget];
        },
        clearWidgets: function (state, action) {
            var widgetSlots = action.payload.slots;
            var slots = widgetSlots && Array.isArray(widgetSlots) ? widgetSlots : [widgetSlots];
            logger.debug("[LAYOUT] - Nettoyage des widgets depuis les emplacements: ", slots);
            slots.forEach(function (slot) {
                if (!Object.hasOwn(state.slots, slot)) {
                    logger.debug("[LAYOUT] - Slot invalide ".concat(slot));
                    return;
                }
                state.slots[slot].widgets = [];
            });
        },
        moveWidgetUp: function (state, action) {
            var found = findWidget(state, action);
            if (!found) {
                return;
            }
            var currentIndex = found.index, slot = found.slot;
            var widget = state.slots[slot].widgets[currentIndex];
            logger.debug("[LAYOUT] - D\u00E9placement [UP] du widget ".concat(widget.id, " dans le slot: ").concat(slot));
            var nextIndex = Math.max(currentIndex - 1, 0);
            moveWidget(widget, state.slots[slot].widgets, currentIndex, nextIndex);
        },
        moveWidgetDown: function (state, action) {
            var found = findWidget(state, action);
            if (!found) {
                return;
            }
            var currentIndex = found.index, slot = found.slot;
            var widget = state.slots[slot].widgets[currentIndex];
            logger.debug("[LAYOUT] - D\u00E9placement [DOWN] du widget ".concat(widget.id, " dans le slot: ").concat(slot));
            var nextIndex = Math.min(currentIndex + 1, state.slots[slot].widgets.length - 1);
            moveWidget(widget, state.slots[slot].widgets, currentIndex, nextIndex);
        },
        moveWidgetFirst: function (state, action) {
            var found = findWidget(state, action);
            if (!found) {
                return;
            }
            var currentIndex = found.index, slot = found.slot;
            var widget = state.slots[slot].widgets[currentIndex];
            logger.debug("[LAYOUT] - D\u00E9placement [FIRST] du widget ".concat(widget.id, " dans le slot: ").concat(slot));
            var nextIndex = 0;
            moveWidget(widget, state.slots[slot].widgets, currentIndex, nextIndex);
        },
        moveWidgetLast: function (state, action) {
            var found = findWidget(state, action);
            if (!found) {
                return;
            }
            var currentIndex = found.index, slot = found.slot;
            var widget = state.slots[slot].widgets[currentIndex];
            logger.debug("[LAYOUT] - D\u00E9placement [LAST] du widget ".concat(widget.id, " dans le slot: ").concat(slot));
            var nextIndex = Math.max(0, state.slots[slot].widgets.length - 1);
            moveWidget(widget, state.slots[slot].widgets, currentIndex, nextIndex);
        },
        startEditlayout: function (state, action) {
            state.editingLayout = true;
            // Copy current state
        },
        endEditLayout: function (state, action) {
            state.editingLayout = false;
        },
        setSlots: function (state, data) {
            state.slots = data.payload;
        },
        setModuleList: function (state, action) {
            var _a;
            var _b = action.payload, widget = _b.widget, module = _b.module, mode = _b.mode;
            if (!state.moduleList) {
                state.moduleList = [];
            }
            var moduleEntry = state.moduleList.find(function (m) { return m[module]; });
            if (!moduleEntry) {
                moduleEntry = (_a = {}, _a[module] = [], _a);
                state.moduleList.push(moduleEntry);
            }
            var moduleWidgets = moduleEntry[module];
            if (mode === "edit") {
                var idx = moduleWidgets.findIndex(function (w) { return w.id === widget.id; });
                if (idx !== -1) {
                    moduleWidgets[idx] = widget;
                }
                else {
                    moduleWidgets.push(widget);
                }
            }
            else {
                moduleWidgets.push(widget);
            }
        },
        setModuleLists: function (state, action) {
            var _a;
            var _b = action.payload, module = _b.module, widget = _b.widget;
            var moduleIndex = state.moduleList.findIndex(function (mod) { return Object.keys(mod)[0] === module; });
            if (moduleIndex !== -1) {
                state.moduleList[moduleIndex][module].push(widget);
            }
            else {
                state.moduleList.push((_a = {}, _a[module] = [widget], _a));
            }
        },
        removeModuleListWidgets: function (state, data) {
            state.moduleList = data.payload;
        },
        removeModuleListWiddgetId: function (state, action) {
            var _a;
            var _b = action.payload, module = _b.module, widgetId = _b.widgetId;
            var moduleIndex = (_a = state.moduleList) === null || _a === void 0 ? void 0 : _a.findIndex(function (mod) { return Object.keys(mod)[0] === module; });
            if (moduleIndex !== -1) {
                var widgetArray = state.moduleList[moduleIndex][module];
                state.moduleList[moduleIndex][module] = widgetArray.filter(function (widget) { return widget.id !== widgetId; });
                // Optional: Remove the module entirely if it has no widgets
                if (state.moduleList[moduleIndex][module].length === 0) {
                    state.moduleList.splice(moduleIndex, 1);
                }
            }
        },
        setWidgets: function (state, action) {
            var _a = action.payload, slot = _a.slot, widgets = _a.widgets;
            state.slots[slot].widgets = widgets;
        },
    },
});
/**
 *
 * @param state
 * @param payload
 * @returns
 */
function findWidget(state, action) {
    var _a = action.payload, id = _a.id, widgetType = _a.type, widgetLocation = _a.slot;
    if (!id) {
        logger.warn("[LAYOUT] - L'identifiant du widget est requis");
        return;
    }
    if (!Object.hasOwn(state.slots, widgetLocation)) {
        logger.warn("[LAYOUT] - Slot inconu: ".concat(widgetLocation, ". Le widget sera recherch\u00E9 dans \"main\""));
    }
    var slot = widgetLocation || Slot.MAIN;
    var widgets = state.slots[slot].widgets;
    var index = widgets.findIndex(function (w) {
        return id && w.id === id && (widgetType ? w.type === widgetType : true);
    });
    if (index < 0) {
        logger.debug("[LAYOUT] - Le widget avec l'id: ".concat(id, " n'existe pas dans le slot: ").concat(slot));
        return;
    }
    return { index: index, slot: slot };
}
/**
 * Change widget position
 *
 * @param widget
 * @param list
 * @param previousIndex
 * @param nextIndex
 */
function moveWidget(widget, list, previousIndex, nextIndex) {
    list.splice(previousIndex, 1);
    list.splice(Math.max(nextIndex, 0), 0, widget);
}
export var setWidgetDisplay = (_a = layoutSliceState.actions, _a.setWidgetDisplay), setDisplaySize = _a.setDisplaySize, addWidget = _a.addWidget, updateWidget = _a.updateWidget, removeWidget = _a.removeWidget, removeWidgetById = _a.removeWidgetById, removeWidgetByType = _a.removeWidgetByType, setWidget = _a.setWidget, clearWidgets = _a.clearWidgets, moveWidgetFirst = _a.moveWidgetFirst, moveWidgetLast = _a.moveWidgetLast, moveWidgetUp = _a.moveWidgetUp, moveWidgetDown = _a.moveWidgetDown, startEditlayout = _a.startEditlayout, endEditLayout = _a.endEditLayout, setSlots = _a.setSlots, setModuleList = _a.setModuleList, setModuleLists = _a.setModuleLists, removeModuleListWiddgetId = _a.removeModuleListWiddgetId, removeModuleListWidgets = _a.removeModuleListWidgets, setWidgets = _a.setWidgets;
export default layoutSliceState.reducer;
